<template>
	<front-admin-hub module-key="auth" />
</template>
<script>
import FrontAdminHub from '@/components/FrontAdminHub/index.vue';
export default {
	name: 'AuthManage',
	components: { FrontAdminHub },
};
</script>
